import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography  } from '@mui/material';

const UserTrainingsPerActivityTable = ({ data }) => {
  return (
    <Paper style={{ maxHeight: '400px', overflowY: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id='userTracking.perActivity.label.title' defaultMessage='Trainings attendance' />
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><FormattedMessage id='userTracking.perActivity.table.name' defaultMessage='Training' /></TableCell>
            <TableCell><FormattedMessage id='userTracking.perActivity.table.count' defaultMessage='Training Count' /></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.name}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.trainingCount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

UserTrainingsPerActivityTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      trainingCount: PropTypes.number,
    })
  ),
};

export { UserTrainingsPerActivityTable };